import type { LinkDetail } from '@/components/shared/link-widget'

// Use Web 2.0 URLs
export const THEATER_TICKETS_BY_CITY_LINKS: LinkDetail[] = [
    { url: '/region/usa/ga/atlanta-tickets/80/theater', label: 'Atlanta Theater' },
    { url: '/region/usa/ma/boston-area-tickets/74/theater', label: 'Boston Theater' },
    { url: '/region/usa/il/chicago-area-tickets/57/theater', label: 'Chicago Theater' },
    { url: '/region/usa/tx/houston-tickets/18/theater', label: 'Houston Theater' },
    { url: '/region/usa/ca/los-angeles-tickets/29/theater', label: 'Los Angeles Theater' },
    { url: '/region/usa/ny/new-york-tickets/7/theater', label: 'New York Theater' },
    { url: '/region/usa/ca/bay-area-tickets/28/theater', label: 'SF Bay Area Theater' },
    { url: '/region/usa/fl/south-florida-tickets/75/theater', label: 'South Florida Theater' },
    { url: '/region', label: 'All Regions' },
]

export const OTHER_THEATER_CATEGORY_LINKS: LinkDetail[] = [
    { url: '/theater/arts', label: 'Arts and Theater' },
    { url: '/theater/broadway', label: 'Broadway' },
    { url: '/theater/cirque', label: 'Cirque' },
    { url: '/comedy', label: 'Comedy' },
    { url: '/theater/family', label: 'Family' },
    { url: '/theater/musicals', label: 'Musical' },
]
